import { fetchGraphQL } from "./libs";
const setBanner = async () => {
  const subscriptionBannerLongContainer = document.querySelector('#js-subscription-banner-long-container'),
    subscriptionBannerContainer = document.querySelector('#js-subscription-banner-container'),
    applyBannerContainer = document.querySelector('#js-apply-banner-container');

  if (!subscriptionBannerLongContainer && !subscriptionBannerContainer && !applyBannerContainer) return false;

  const uri = new URL(window.location.href);
  const GET_POSTS = `
    {
      settingsPost(id: ${uri.host === 'www.aiia-pub.com' ? '718' : '151'} idType: DATABASE_ID) {
        bannerSettings {
          subscriptionBannerLong {
            node {
              sourceUrl
            }
          }
          subscriptionBanner {
            node {
              sourceUrl
            }
          }
          applyBanner {
            node {
              sourceUrl
            }
          }
        }
      }
    }
  `;

  const res = await fetchGraphQL(GET_POSTS),
    targetData = res.settingsPost.bannerSettings,
    subscriptionBannerLongLink = targetData.subscriptionBannerLong.node.sourceUrl,
    subscriptionBannerLink = targetData.subscriptionBanner.node.sourceUrl,
    applyBannerLink = targetData.applyBanner.node.sourceUrl;

  if (subscriptionBannerLongContainer) {
    const html = `
                  <picture>
                    <source media="(max-width:767px)" srcset="${subscriptionBannerLink}">
                    <img src="${subscriptionBannerLongLink}" alt="定期購読">
                  </picture>`;

    subscriptionBannerLongContainer.innerHTML = html;
  }

  if (subscriptionBannerContainer) {
    const html = `
                  <picture>
                    <source media="(max-width:767px)" srcset="${subscriptionBannerLink}">
                    <img src="${subscriptionBannerLink}" alt="定期購読">
                  </picture>`;

    subscriptionBannerContainer.innerHTML = html;
  }

  if (applyBannerContainer) {
    const html = `
                  <picture>
                    <source media="(max-width:767px)" srcset="${applyBannerLink}">
                    <img src="${applyBannerLink}" alt="IDひとつで宛名書き不要!　ラクラク応募">
                  </picture>`;

    applyBannerContainer.innerHTML = html;
  }
};

export default setBanner;